import React from 'react';
import SvgIcon from './SvgIcon';

export const AddIcon = props => (
  <SvgIcon {...props}>
    <path d="M50 22.62H27.38V0h-4.76v22.62H0v4.76h22.62V50h4.76V27.38H50v-4.76z" />
  </SvgIcon>
);

export const EmptyIcon = props => (
  <SvgIcon viewBox="0 0 28 28" {...props}>
    <path
      d="M0.282793 0.282793C0.659851 -0.0942645 1.27118 -0.0942645 1.64824 0.282793L27.7172 26.3518C28.0943 26.7288 28.0943 27.3401 27.7172 27.7172C27.3401 28.0943 26.7288 28.0943 26.3518 27.7172L0.282793 1.64824C-0.0942645 1.27118 -0.0942645 0.659851 0.282793 0.282793Z"
      fill="#FF0000"
    />
  </SvgIcon>
);

export const InsetClipPath = props => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M15.3333 9.33333C14.9333 9.33333 14.6667 9.6 14.6667 10V11.3333C14.6667 11.7333 14.9333 12 15.3333 12C15.7333 12 16 11.7333 16 11.3333V10C16 9.6 15.7333 9.33333 15.3333 9.33333Z"
      fill="white"
    />
    <path
      d="M15.3333 13.3333C14.9333 13.3333 14.6667 13.6 14.6667 14V14.6667H14C13.6 14.6667 13.3333 14.9333 13.3333 15.3333C13.3333 15.7333 13.6 16 14 16H15.3333C15.6 16 15.8667 15.8667 15.9333 15.6C16 15.5333 16 15.4 16 15.3333V14C16 13.6 15.7333 13.3333 15.3333 13.3333Z"
      fill="white"
    />
    <path
      d="M15.3333 5.33333C14.9333 5.33333 14.6667 5.6 14.6667 6V7.33333C14.6667 7.73333 14.9333 8 15.3333 8C15.7333 8 16 7.73333 16 7.33333V6C16 5.6 15.7333 5.33333 15.3333 5.33333Z"
      fill="white"
    />
    <path
      d="M7.33333 14.6667H6C5.6 14.6667 5.33333 14.9333 5.33333 15.3333C5.33333 15.7333 5.6 16 6 16H7.33333C7.73333 16 8 15.7333 8 15.3333C8 14.9333 7.73333 14.6667 7.33333 14.6667Z"
      fill="white"
    />
    <path
      d="M11.3333 14.6667H10C9.6 14.6667 9.33333 14.9333 9.33333 15.3333C9.33333 15.7333 9.6 16 10 16H11.3333C11.7333 16 12 15.7333 12 15.3333C12 14.9333 11.7333 14.6667 11.3333 14.6667Z"
      fill="white"
    />
    <path
      d="M8.66661 1.3334H7.33328L1.33328 1.3334L1.33328 7.3334V8.66673V13.7334L13.7333 1.3334H8.66661Z"
      fill="#5A5A5A"
    />
    <path
      d="M0 15.3333C0 15.4 0 15.4667 0.0666666 15.5333C0.0666666 15.5333 0.0666666 15.6 0.133333 15.6C0.133333 15.6667 0.199999 15.6667 0.199999 15.7333L0.266666 15.8C0.333333 15.8 0.333333 15.8667 0.4 15.8667C0.4 15.8667 0.466667 15.8667 0.466667 15.9333C0.466667 16 0.599999 16 0.666666 16H0.933332H2H3.33333C3.73333 16 4 15.7333 4 15.3333C4 14.9333 3.73333 14.6667 3.33333 14.6667H2.26667H2H1.33333L14.6667 1.4V2V2.93333V3.33333C14.6667 3.73333 14.9333 4 15.3333 4C15.7333 4 16 3.73333 16 3.33333V2L16 0.933332V0.666666C16 0.4 15.8667 0.133333 15.6 0.0666666C15.5333 0 15.4 0 15.3333 0H15.0667H14H8.66667H7.33333L0.666666 0C0.4 0 0.133333 0.133333 0.0666666 0.4C0 0.466666 0 0.599999 0 0.666666V7.33333V8.66667L0 14V15.0667V15.3333ZM1.33333 13.7333L1.33333 8.66667V7.33333V1.33333H7.33333H8.66667L13.7333 1.33333L1.33333 13.7333ZM13.3333 0.733334H15.3333L0.933332 0.8L13.3333 0.733334Z"
      fill="white"
    />
    <path
      d="M0.4 15.9333C0.466666 16 0.599999 16 0.666666 16H0.866666L2.13333 14.7333L14.7333 2.2L16 0.866666V0.666666C16 0.4 15.8667 0.133333 15.6 0.0666666C15.5333 0 15.4 0 15.3333 0H15L13.6667 1.33333L1.33333 13.6667L0 15V15.3333C0 15.6 0.133333 15.8667 0.4 15.9333Z"
      fill="white"
    />
  </SvgIcon>
);
export const MultipleObjects = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 9C21 9.55229 20.5523 10 20 10H18V16C18 17.1046 17.1046 18 16 18H10V20C10 20.5523 9.55229 21 9 21C8.44771 21 8 20.5523 8 20V18H2C0.89543 18 0 17.1046 0 16V2C0 0.89543 0.89543 0 2 0H16C17.1046 0 18 0.89543 18 2V8H20C20.5523 8 21 8.44771 21 9ZM2 2V16H8V9C8 8.44771 8.44771 8 9 8H16V2H2ZM16 16H10V10H16V16ZM23 8C22.4477 8 22 8.44771 22 9V11C22 11.5523 22.4477 12 23 12C23.5523 12 24 11.5523 24 11V9C24 8.44771 23.5523 8 23 8ZM22 15C22 14.4477 22.4477 14 23 14C23.5523 14 24 14.4477 24 15V17C24 17.5523 23.5523 18 23 18C22.4477 18 22 17.5523 22 17V15ZM22 21C22 20.4477 22.4477 20 23 20C23.5523 20 24 20.4477 24 21V23C24.0012 23.1385 23.9704 23.2754 23.91 23.4C23.7519 23.7623 23.3953 23.9974 23 24H21C20.4477 24 20 23.5523 20 23C20 22.4477 20.4477 22 21 22H22V21ZM8 23C8 22.4477 8.44771 22 9 22H11C11.5523 22 12 22.4477 12 23C12 23.5523 11.5523 24 11 24H9C8.44771 24 8 23.5523 8 23ZM18 23C18 22.4477 17.5523 22 17 22H15C14.4477 22 14 22.4477 14 23C14 23.5523 14.4477 24 15 24H17C17.5523 24 18 23.5523 18 23Z"
      fill="white"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 9C21 9.55229 20.5523 10 20 10H18V16C18 17.1046 17.1046 18 16 18H10V20C10 20.5523 9.55229 21 9 21C8.44771 21 8 20.5523 8 20V18H2C0.89543 18 0 17.1046 0 16V2C0 0.89543 0.89543 0 2 0H16C17.1046 0 18 0.89543 18 2V8H20C20.5523 8 21 8.44771 21 9ZM2 2V16H8V9C8 8.44771 8.44771 8 9 8H16V2H2ZM16 16H10V10H16V16ZM23 8C22.4477 8 22 8.44771 22 9V11C22 11.5523 22.4477 12 23 12C23.5523 12 24 11.5523 24 11V9C24 8.44771 23.5523 8 23 8ZM22 15C22 14.4477 22.4477 14 23 14C23.5523 14 24 14.4477 24 15V17C24 17.5523 23.5523 18 23 18C22.4477 18 22 17.5523 22 17V15ZM22 21C22 20.4477 22.4477 20 23 20C23.5523 20 24 20.4477 24 21V23C24.0012 23.1385 23.9704 23.2754 23.91 23.4C23.7519 23.7623 23.3953 23.9974 23 24H21C20.4477 24 20 23.5523 20 23C20 22.4477 20.4477 22 21 22H22V21ZM8 23C8 22.4477 8.44771 22 9 22H11C11.5523 22 12 22.4477 12 23C12 23.5523 11.5523 24 11 24H9C8.44771 24 8 23.5523 8 23ZM18 23C18 22.4477 17.5523 22 17 22H15C14.4477 22 14 22.4477 14 23C14 23.5523 14.4477 24 15 24H17C17.5523 24 18 23.5523 18 23Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect width="24" height="24" fill="white" />
    </g>
  </SvgIcon>
);

export const MultipleImages = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 0H1C0.447715 0 0 0.447715 0 1V23C0 23.5523 0.447715 24 1 24H23C23.5523 24 24 23.5523 24 23V1C24 0.447715 23.5523 0 23 0ZM22 2V13.59L19.21 10.79C19.0222 10.6007 18.7666 10.4942 18.5 10.4942C18.2334 10.4942 17.9778 10.6007 17.79 10.79L12 16.59L7.71 12.29C7.52223 12.1007 7.26664 11.9942 7 11.9942C6.73336 11.9942 6.47777 12.1007 6.29 12.29L2 16.59V2H22ZM2 22V19.41L7 14.41L11.29 18.71C11.4778 18.8993 11.7334 19.0058 12 19.0058C12.2666 19.0058 12.5222 18.8993 12.71 18.71L18.5 12.91L21.86 16.27V22H2ZM7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10ZM8 7C8 6.44772 7.55228 6 7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8C7.55228 8 8 7.55228 8 7Z"
      fill="white"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 0H1C0.447715 0 0 0.447715 0 1V23C0 23.5523 0.447715 24 1 24H23C23.5523 24 24 23.5523 24 23V1C24 0.447715 23.5523 0 23 0ZM22 2V13.59L19.21 10.79C19.0222 10.6007 18.7666 10.4942 18.5 10.4942C18.2334 10.4942 17.9778 10.6007 17.79 10.79L12 16.59L7.71 12.29C7.52223 12.1007 7.26664 11.9942 7 11.9942C6.73336 11.9942 6.47777 12.1007 6.29 12.29L2 16.59V2H22ZM2 22V19.41L7 14.41L11.29 18.71C11.4778 18.8993 11.7334 19.0058 12 19.0058C12.2666 19.0058 12.5222 18.8993 12.71 18.71L18.5 12.91L21.86 16.27V22H2ZM7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10ZM8 7C8 6.44772 7.55228 6 7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8C7.55228 8 8 7.55228 8 7Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect width="24" height="24" fill="white" />
    </g>
  </SvgIcon>
);

export const AddSquareIcon = props => (
  <SvgIcon {...props}>
    <path d="M 47.916667,50 H 2.0833333 A 2.0833333,2.0833333 0 0 1 0,47.916667 V 2.0833333 A 2.0833333,2.0833333 0 0 1 2.0833333,0 H 47.916667 A 2.0833333,2.0833333 0 0 1 50,2.0833333 V 47.916667 A 2.0833333,2.0833333 0 0 1 47.916667,50 Z M 4.1666667,45.833333 H 45.833333 V 4.1666667 H 4.1666667 Z" />
    <path d="M 39.583333,27.083333 H 10.416667 a 2.0833333,2.0833333 0 0 1 0,-4.166666 h 29.166666 a 2.0833333,2.0833333 0 0 1 0,4.166666 z" />
    <path d="M 25,41.666667 A 2.0833333,2.0833333 0 0 1 22.916667,39.583333 V 10.416667 a 2.0833333,2.0833333 0 0 1 4.166666,0 V 39.583333 A 2.0833333,2.0833333 0 0 1 25,41.666667 Z" />
  </SvgIcon>
);

export const ArrowLeft = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="m6 14 11 11c0.3 0.3 0.6 0.4 1 0.3 0.3-0.09 0.6-0.4 0.7-0.7 0.09-0.3-6e-3 -0.7-0.3-1l-10-10 10-10c0.3-0.3 0.4-0.6 0.3-1-0.09-0.3-0.4-0.6-0.7-0.7-0.3-0.09-0.7 6e-3 -1 0.3l-11 11c-0.2 0.2-0.3 0.4-0.3 0.7s0.1 0.5 0.3 0.7z" />
  </SvgIcon>
);

export const ArrowDownIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M49.1 11.9c-.6-.6-1.4-.9-2.2-.9H3.1c-.8 0-1.6.3-2.2.9-.6.6-.9
    1.3-.9 2.2 0 .8.3 1.6.9 2.2l21.9 21.9c.6.6 1.4.9 2.2.9.8 0 1.6-.3
    2.2-.9l21.9-21.9c.6-.6.9-1.4.9-2.2 0-.9-.3-1.6-.9-2.2zm0 0"
    />
  </SvgIcon>
);

export const ArrowUpIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M49.1 33.7L27.2 11.9c-.6-.6-1.4-.9-2.2-.9s-1.6.3-2.2.9L.9
    33.7c-.6.7-.9 1.4-.9 2.2 0 .8.3 1.6.9 2.2.6.6 1.4.9
    2.2.9h43.7c.8 0 1.6-.3 2.2-.9.6-.6.9-1.4.9-2.2.1-.8-.2-1.5-.8-2.2zm0 0"
    />
  </SvgIcon>
);

export const ClockIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M25 45.2c-9.3 0-16.7-7.4-16.7-16.7S15.7 11.9 25 11.9s16.7 7.4
    16.7 16.7S34.3 45.2 25 45.2m16.7-30l3.6-3.3c-1.2-1.2-2.4-2.4-3.6-3.3l-3.3
    3.3C34.5 8.8 30 7.1 25 7.1c-11.9 0-21.4 9.5-21.4 21.4S13.1 50 25 50s21.4-9.5
    21.4-21.4c0-5-1.6-9.8-4.7-13.4M22.6 31h4.8V16.7h-4.8M32.1 0H17.9v4.8h14.3V0z"
    />
  </SvgIcon>
);

export const CursorIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M 43.9,37.1 30.5,23.7 40.3,19.5 c 0.8,-0.3 1.2,-1.1 1.2,
    -1.9 0,-0.8 -0.6,-1.5 -1.4,-1.8 L 8.1,5.6 C 7.4,5.4 6.6,5.6 6.1,
    6.1 5.6,6.6 5.4,7.4 5.6,8.1 l 10.2,32 c 0.3,0.8 1,1.3 1.8,1.4 0.8,
    0.1 1.6,-0.4 1.9,-1.2 l 4.2,-9.8 13.4,13.4 c 0.4,0.4 0.9,0.6 1.4,
    0.6 0.5,0 1,-0.2 1.4,-0.6 l 4,-4 c 0.8,-0.8 0.8,-2 0,-2.8 z m 0,0"
    />
  </SvgIcon>
);

export const EditIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M23.4 14.8l-4.8 4.9-5.4 5.4c-.4.4-.7 1-.9 1.6-.6 3-1.3
    5.9-1.9 8.9l-.3 1.6c-.2.8.1 1.6.6 2.1.4.4 1 .7 1.6.7.2 0 .3 0
    .5-.1l1.8-.4c2.9-.6 5.7-1.2 8.6-1.8.7-.1 1.2-.4 1.7-.9 8-8 16-16.1
    24-24.1.6-.6.9-1.3
    1-2.2v-.4c-.1-.2-.1-.4-.1-.6-.1-.5-.2-1.1-.5-1.7-1.5-3.4-4-5.9-7.4-7.3
    -.7-.3-1.4-.4-2-.4h-.2c-.9-.2-1.7.1-2.4.9-4.6
    4.6-9.2 9.2-13.9 13.8zm16-12.3h.2c.5.1 1 .1 1.4.3 2.8 1.1 4.8 3.1 6
    5.9.1.3.2.7.3 1.2 0 .2.1.3.1.5s-.1.3-.3.4c-8 8-16 16.1-24.1
    24.1-.1.1-.3.2-.4.2-2.9.6-5.7 1.2-8.6 1.8l-1.5.3.3-1.3c.6-2.9 1.2-5.9
    1.9-8.8 0-.1.1-.2.2-.3 1.8-1.8 3.5-3.6 5.3-5.4l4.8-4.9c4.6-4.6 9.2-9.3
    13.8-13.9.4-.1.5-.1.6-.1zm0 0"
    />
    <path
      d="M4 11.1h17.8c.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3H4c-2.2 0-4
    1.8-4 4V46c0 2.2 1.8 4 4 4h33.4c2.2 0 4-1.8 4-4V28.9c0-.7-.6-1.3-1.3-1.3-.7
    0-1.3.6-1.3 1.3V46c0 .8-.7 1.5-1.5 1.5H4c-.8 0-1.5-.7-1.5-1.5V12.6c0-.8.7-1.5
    1.5-1.5zm0 0"
    />
  </SvgIcon>
);

export const FolderIcon = props => (
  <SvgIcon {...props}>
    <path d="M 47.916667,23.333333 H 2.0833333 a 2.0833333,2.0833333 0 0 1 0,-4.166666 H 47.916667 a 2.0833333,2.0833333 0 0 1 0,4.166666 z" />
    <path d="M 47.916667,50 H 2.0833333 A 2.0833333,2.0833333 0 0 1 0,47.916667 V 2.0833333 A 2.0833333,2.0833333 0 0 1 2.0833333,0 H 22.916667 A 2.0833333,2.0833333 0 0 1 25,2.0833333 V 10.416667 H 47.916667 A 2.0833333,2.0833333 0 0 1 50,12.5 V 47.916667 A 2.0833333,2.0833333 0 0 1 47.916667,50 Z M 4.1666667,45.833333 H 45.833333 v -31.25 H 22.916667 A 2.0833333,2.0833333 0 0 1 20.833333,12.5 V 4.1666667 H 4.1666667 Z" />
  </SvgIcon>
);

export const FullCircleIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M24.6 0C38.4-.2 49.8 10.8 50 24.6c.2 13.8-10.8 25.2-24.6
    25.4h-.8C10.8 49.8-.2 38.4 0 24.6.2 11.1 11.1.2 24.6 0z"
    />
  </SvgIcon>
);

export const MarkIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M18,1a1,1,0,0,0-1-1H7A1,1,0,0,0,6,1V17s0,0,0,.05a.91.91,0,0,0,.06.32,0,0,0,0,1,0,0,1.28,1.28,0,0,0,.15.25l5,6a1,1,0,0,0,1.54,0l5-6a1.28,1.28,0,0,0,.15-.25,0,0,0,0,1,0,0,.87.87,0,0,0,.06-.32s0,0,0-.05Z" />
  </SvgIcon>
);

export const OneStepToBottomIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M18.29,10.71l2,2h0a1,1,0,0,0,1.4,0h0l2-2a1,1,0,0,0-1.42-1.41L22,9.59V1a1,1,0,0,0-2,0V9.59l-.29-.29a1,1,0,0,0-1.42,1.41Z" />
    <path d="M15,19H1a1,1,0,0,1,0-2H15a1,1,0,0,1,0,2Z" />
    <path d="M15,7H1A1,1,0,0,1,1,5H15a1,1,0,0,1,0,2Z" />
    <path d="M2.5,13H1a1,1,0,0,1,0-2H2.5a1,1,0,0,1,0,2Z" />
    <path d="M10.75,13H9.38a1,1,0,0,1,0-2h1.38a1,1,0,0,1,0,2ZM6.63,13H5.25a1,1,0,0,1,0-2H6.63a1,1,0,0,1,0,2Z" />
    <path d="M15,13H13.5a1,1,0,0,1,0-2H15a1,1,0,0,1,0,2Z" />
  </SvgIcon>
);

export const OneStepToTopIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M18.29,14.71a1,1,0,0,0,1.41,0l.29-.29V23a1,1,0,0,0,2,0V14.41l.29.29a1,1,0,0,0,1.42-1.41l-2-2h0a1,1,0,0,0-1.4,0h0l-2,2A1,1,0,0,0,18.29,14.71Z" />
    <path d="M15,19H1a1,1,0,0,1,0-2H15a1,1,0,0,1,0,2Z" />
    <path d="M15,7H1A1,1,0,0,1,1,5H15a1,1,0,0,1,0,2Z" />
    <path d="M2.5,13H1a1,1,0,0,1,0-2H2.5a1,1,0,0,1,0,2Z" />
    <path d="M10.75,13H9.38a1,1,0,0,1,0-2h1.38a1,1,0,0,1,0,2ZM6.63,13H5.25a1,1,0,0,1,0-2H6.63a1,1,0,0,1,0,2Z" />
    <path d="M15,13H13.5a1,1,0,0,1,0-2H15a1,1,0,0,1,0,2Z" />
  </SvgIcon>
);

export const PauseIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M17.3 0H7.7C5.6 0 3.8 1.7 3.8 3.8v42.3c0 2.1 1.7 3.8
    3.8 3.8h9.6c2.1 0 3.8-1.7 3.8-3.8V3.8c.2-2.1-1.6-3.8-3.7-3.8zm25
    0h-9.6c-2.1 0-3.8 1.7-3.8 3.8v42.3c0 2.1 1.7 3.8 3.8 3.8h9.6c2.1
    0 3.8-1.7 3.8-3.8V3.8c.1-2.1-1.7-3.8-3.8-3.8z"
    />
  </SvgIcon>
);

export const PlayIcon = props => (
  <SvgIcon {...props}>
    <path d="M11.7 50V0l26.7 25c-.1 0-26.7 25-26.7 25z" />
  </SvgIcon>
);

export const Spinner = props => (
  <SvgIcon {...props}>
    <g>
      <path
        fill="#424242"
        d="M25,12.5c-6.9,0-12.5,5.6-12.5,12.5S18.1,
      37.5,25,37.5S37.5,31.9,37.5,25S31.9,12.5,25,12.5z M25,36.2
      c-6.1,0-11.1-5-11.1-11.2s5-11.1,11.1-11.1s11.2,5,11.2,11.1S31.1,36.2,25,36.2z"
      />
      <path
        fill="#FCC015"
        d="M13.9,25c0-6.1,4.9-11.1,11.1-11.1v-1.4C18,12.6,12.5,18.1,12.5,25H13.9z"
      />
    </g>
  </SvgIcon>
);

export const ToBottomIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M15,13H1a1,1,0,0,1,0-2H15a1,1,0,0,1,0,2Z" />
    <path d="M15,7H1A1,1,0,0,1,1,5H15a1,1,0,0,1,0,2Z" />
    <path d="M18.29,16.71l2,2h0a1,1,0,0,0,1.4,0h0l2-2a1,1,0,0,0-1.42-1.41l-.29.29V1a1,1,0,0,0-2,0V15.59l-.29-.29a1,1,0,0,0-1.42,1.41Z" />
    <path d="M15,19H13.5a1,1,0,0,1,0-2H15a1,1,0,0,1,0,2Z" />
    <path d="M10.75,19H9.38a1,1,0,0,1,0-2h1.38a1,1,0,0,1,0,2ZM6.63,19H5.25a1,1,0,0,1,0-2H6.63a1,1,0,0,1,0,2Z" />
    <path d="M2.5,19H1a1,1,0,0,1,0-2H2.5a1,1,0,0,1,0,2Z" />
  </SvgIcon>
);

export const ToTopIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M15,7H13.5a1,1,0,0,1,0-2H15a1,1,0,0,1,0,2Z" />
    <path d="M10.75,7H9.38a1,1,0,0,1,0-2h1.38a1,1,0,0,1,0,2ZM6.63,7H5.25a1,1,0,0,1,0-2H6.63a1,1,0,0,1,0,2Z" />
    <path d="M2.5,7H1A1,1,0,0,1,1,5H2.5a1,1,0,0,1,0,2Z" />
    <path d="M15,19H1a1,1,0,0,1,0-2H15a1,1,0,0,1,0,2Z" />
    <path d="M15,13H1a1,1,0,0,1,0-2H15a1,1,0,0,1,0,2Z" />
    <path d="M23.71,7.29l-2-2h0a1,1,0,0,0-1.4,0h0l-2,2a1,1,0,0,0,1.42,1.41L20,8.41V23a1,1,0,0,0,2,0V8.41l.29.29a1,1,0,0,0,1.42-1.41Z" />
  </SvgIcon>
);

export const TrashIcon = props => (
  <SvgIcon {...props}>
    <g>
      <path
        d="M41.35 5.89h-6.67V1.55A1.55 1.55 0 0 0 33.1 0a.24.24 0 0
      0-.17.06.21.21 0 0 0-.11-.06H16.9a1.53 1.53 0 0 0-1.55 1.55v4.34h-6.7A3.37
      3.37 0 0 0 5.24 9.3v5.58h3v31.74A3.32 3.32 0 0 0 11.58 50h26.84a3.34
      3.34 0 0 0 3.41-3.38V14.87h2.93V9.3a3.37 3.37 0 0 0-3.41-3.41zM18.45
      3.1h13.1v2.79h-13.1zM38.7 46.62c0 .2-.08.28-.28.28H11.58c-.2
      0-.28-.08-.28-.28V14.87h27.4zm2.93-34.84H8.37V9.3c0-.2.08-.31.28-.31h32.7c.2
      0 .28.11.28.31v2.48z"
      />
      <path
        d="M30.68 18.51h3.13v25.63h-3.13zM23.46 18.51h3.13v25.63h-3.13zM16.25
      18.51h3.13v25.63h-3.13z"
      />
    </g>
  </SvgIcon>
);

export const AlignLeftIcon = props => (
  <SvgIcon {...props}>
    <path d="M35.45 21.67H11.21a2 2 0 0 1-2-2.05V7a2 2 0 0 1 2-2h24.24a2 2 0 0 1 2.05 2v12.62a2 2 0 0 1-2 2.05zm0 0" />
    <path d="M43.79 45H11.21a2 2 0 0 1-2-2V30.38a2 2 0 0 1 2-2.05h32.57a2.05 2.05 0 0 1 2.05 2.05V43a2 2 0 0 1-2 2zm0 0M5 50a.83.83 0 0 1-.83-.83V.83a.83.83 0 1 1 1.67 0v48.34A.84.84 0 0 1 5 50zm0 0" />
  </SvgIcon>
);

export const AlignCenterIcon = props => (
  <SvgIcon {...props}>
    <path d="M25 5.84a.84.84 0 0 1-.83-.84V.83a.83.83 0 1 1 1.66 0V5a.83.83 0 0 1-.83.83zm0 0M25 29.17a.83.83 0 0 1-.83-.83v-6.67a.83.83 0 1 1 1.66 0v6.66a.83.83 0 0 1-.83.83zm0 0M25 50a.83.83 0 0 1-.83-.83V45a.83.83 0 1 1 1.66 0v4.17A.83.83 0 0 1 25 50zm0 0" />
    <path d="M41.29 45H8.71a2 2 0 0 1-2-2V30.38a2 2 0 0 1 2-2.05h32.58a2 2 0 0 1 2 2.05V43a2 2 0 0 1-2 2zm0 0M37.12 21.67H12.88a2 2 0 0 1-2-2.05V7a2 2 0 0 1 2-2h24.24a2 2 0 0 1 2 2v12.62a2 2 0 0 1-2 2.05zm0 0" />
  </SvgIcon>
);

export const AlignRightIcon = props => (
  <SvgIcon {...props}>
    <path d="M6.21 45h32.58a2 2 0 0 0 2-2V30.38a2 2 0 0 0-2-2.05H6.21a2 2 0 0 0-2 2.05V43a2 2 0 0 0 2 2zm0 0M45 50a.84.84 0 0 1-.83-.83V.83a.83.83 0 1 1 1.67 0v48.34A.83.83 0 0 1 45 50zm0 0M38.79 21.67H14.55a2 2 0 0 1-2-2.05V7a2 2 0 0 1 2-2h24.24a2 2 0 0 1 2 2v12.62a2 2 0 0 1-2 2.05zm0 0" />
  </SvgIcon>
);

export const AlignTopIcon = props => (
  <SvgIcon {...props}>
    <path d="M28.33 35.45V11.21a2 2 0 0 1 2.05-2H43a2 2 0 0 1 2 2v24.24a2 2 0 0 1-2 2.05H30.38a2 2 0 0 1-2.05-2zm0 0M5 43.79V11.21a2 2 0 0 1 2-2h12.62a2 2 0 0 1 2.05 2v32.57a2.05 2.05 0 0 1-2.05 2.05H7a2 2 0 0 1-2-2zm0 0M49.17 5.84H.83a.83.83 0 0 1 0-1.67h48.34a.83.83 0 1 1 0 1.67zm0 0" />
  </SvgIcon>
);

export const AlignMiddleIcon = props => (
  <SvgIcon {...props}>
    <path d="M49.17 25.83H45a.83.83 0 1 1 0-1.66h4.17a.83.83 0 1 1 0 1.66zm0 0M28.33 25.83h-6.66a.83.83 0 1 1 0-1.66h6.66a.83.83 0 1 1 0 1.66zm0 0M5 25.83H.83a.83.83 0 1 1 0-1.66H5a.83.83 0 1 1 0 1.66zm0 0" />
    <path d="M5 41.29V8.71a2 2 0 0 1 2-2h12.62a2 2 0 0 1 2.05 2v32.58a2 2 0 0 1-2.05 2H7a2 2 0 0 1-2-2zm0 0M28.33 37.12V12.88a2 2 0 0 1 2.05-2H43a2 2 0 0 1 2 2v24.24a2 2 0 0 1-2 2H30.38a2 2 0 0 1-2.05-2zm0 0" />
  </SvgIcon>
);

export const AlignBottomIcon = props => (
  <SvgIcon {...props}>
    <path d="M28.33 14.55v24.24a2 2 0 0 0 2.05 2H43a2 2 0 0 0 2-2V14.55a2 2 0 0 0-2-2H30.38a2 2 0 0 0-2.05 2zm0 0M5 6.21v32.58a2 2 0 0 0 2 2h12.62a2 2 0 0 0 2.05-2V6.21a2 2 0 0 0-2.05-2H7a2 2 0 0 0-2 2zm0 0M49.17 45.83H.83a.83.83 0 0 1 0-1.67h48.34a.83.83 0 1 1 0 1.67zm0 0" />
  </SvgIcon>
);

export const DistributeCenterH = props => (
  <SvgIcon {...props}>
    <path d="M36.67 50a.83.83 0 0 1-.83-.83v-10a.83.83 0 1 1 1.66 0v10a.83.83 0 0 1-.83.83zm0 0M13.33 50a.84.84 0 0 1-.83-.83v-10a.83.83 0 1 1 1.67 0v10a.84.84 0 0 1-.83.83zm0 0M36.67 11.67a.83.83 0 0 1-.83-.83V.83a.83.83 0 1 1 1.66 0v10a.83.83 0 0 1-.83.83zm0 0M13.33 11.67a.83.83 0 0 1-.83-.83V.83a.83.83 0 1 1 1.67 0v10a.83.83 0 0 1-.83.83zm0 0" />
    <path d="M28.33 37.12V12.88a2.05 2.05 0 0 1 2.05-2.05H43a2 2 0 0 1 2 2.05v24.24a2 2 0 0 1-2 2.05H30.38a2.05 2.05 0 0 1-2.05-2.05zm0 0" />
    <path d="M5 8.72v32.56a2 2 0 0 0 2 2.05h12.62a2.05 2.05 0 0 0 2.05-2.05V8.72a2 2 0 0 0-2-2.05H7a2 2 0 0 0-2 2.05zm0 0" />
  </SvgIcon>
);

export const DistributeJustifiedH = props => (
  <SvgIcon {...props}>
    <path d="M33.2.8a.86.86,0,0,0-.8-.8.79.79,0,0,0-.8.8v10h0V39.2h0v10a.86.86,0,0,0,.8.8.79.79,0,0,0,.8-.8V8.55h0Z" />
    <path d="M18.2.9a.8.8,0,0,0-1.6,0V8.75a2.16,2.16,0,0,0-2-2.1H2a2.16,2.16,0,0,0-2,2.1v32.6a1.92,1.92,0,0,0,1.9,2H14.6a2,2,0,0,0,2-2V49.2a.86.86,0,0,0,.8.8.79.79,0,0,0,.8-.8V37.5a.85.85,0,0,0,0-.23,2.59,2.59,0,0,0,0-.41V6.51h0ZM16.6,16.7h0V36.86a3,3,0,0,0,0,.43.71.71,0,0,0,0,.21Z" />
    <path d="M48,10.85H35.2a1.92,1.92,0,0,0-1.9,2v24.2a2.05,2.05,0,0,0,2.1,2.1H48.1a1.92,1.92,0,0,0,1.9-2V12.85A2,2,0,0,0,48,10.85Z" />
  </SvgIcon>
);

export const DistributeCenterV = props => (
  <SvgIcon {...props}>
    <path d="M49.17 14.17h-10a.83.83 0 0 1 0-1.67h10a.83.83 0 1 1 0 1.67zm0 0M49.17 37.5H37.5a.83.83 0 1 1 0-1.66h11.67a.83.83 0 1 1 0 1.66zm0 0M10.83 14.17h-10a.83.83 0 0 1 0-1.67h10a.83.83 0 0 1 0 1.67zm0 0M16.67 37.5H.83a.83.83 0 1 1 0-1.66h15.84a.83.83 0 1 1 0 1.66zm0 0" />
    <path d="M37.12 21.67H12.88a2 2 0 0 1-2.05-2V7a2 2 0 0 1 2.05-2h24.24a2 2 0 0 1 2.05 2v12.62a2.05 2.05 0 0 1-2.05 2.05zm0 0" />
    <path d="M8.72 45h32.56a2 2 0 0 0 2.05-2V30.38a2.05 2.05 0 0 0-2.05-2.05H8.72a2.05 2.05 0 0 0-2.05 2.05V43a2 2 0 0 0 2.05 2zm0 0" />
  </SvgIcon>
);

export const DistributeJustifiedV = props => (
  <SvgIcon {...props}>
    <path d="M49.2,31.8H37.5a.85.85,0,0,0-.23,0,2.59,2.59,0,0,0-.41,0H.9a.8.8,0,1,0,0,1.6H8.75a2.16,2.16,0,0,0-2.1,2V48a2.16,2.16,0,0,0,2.1,2h32.6a1.92,1.92,0,0,0,2-1.9V35.4a2,2,0,0,0-2-2H49.2a.86.86,0,0,0,.8-.8A.79.79,0,0,0,49.2,31.8ZM16.7,33.4H36.86a3,3,0,0,0,.43,0,1.3,1.3,0,0,0,.21,0Z" />
    <path d="M.8,18.4H49.2a.86.86,0,0,0,.8-.8.79.79,0,0,0-.8-.8H.8a.86.86,0,0,0-.8.8A.79.79,0,0,0,.8,18.4Z" />
    <path d="M12.85,16.7h24.2a2.05,2.05,0,0,0,2.1-2.1V1.9a1.92,1.92,0,0,0-2-1.9H12.85a2,2,0,0,0-2,2V14.8A1.92,1.92,0,0,0,12.85,16.7Z" />
  </SvgIcon>
);

export const KeepAspectRatioIcon = props => (
  <SvgIcon {...props}>
    <path
      fill="#FFFFFF"
      d="M23.6,34.5h2.8c0.8,0,1.4-0.7,1.4-1.7V17.2c0-0.9-0.6-1.7-1.4-1.7h-2.8c-0.8,0-1.4,0.7-1.4,1.7v15.6 C22.2,33.8,22.8,34.5,23.6,34.5z"
    />
    <path
      fill="#FFFFFF"
      d="M18.8,14.2c0-1.9,0.6-3.8,1.8-5.2c2.4-2.8,6.4-2.8,8.7,0c1.2,1.4,1.8,3.3,1.8,5.2v5.9c0,0.9,0.6,1.7,1.4,1.7 l2.8,0c0.8,0,1.4-0.7,1.4-1.7v-5.9c0-3.8-1.2-7.3-3.5-10.1c-4.6-5.5-12.1-5.5-16.7,0C14.3,6.7,13,10.4,13,14.2l0,5.9 c0,0.9,0.6,1.7,1.4,1.7h2.8c0.8,0,1.4-0.7,1.4-1.7L18.8,14.2z"
    />
    <path
      fill="#FFFFFF"
      d="M36.8,35.8v-5.9c0-0.9-0.6-1.7-1.4-1.7h-2.8c-0.8,0-1.4,0.7-1.4,1.7v5.9c0,1.9-0.6,3.8-1.8,5.2 c-2.4,2.8-6.4,2.8-8.7,0c-1.2-1.4-1.8-3.3-1.8-5.2v-5.9c0-0.9-0.6-1.7-1.4-1.7h-2.8c-0.8,0-1.4,0.7-1.4,1.7v5.9 c0,3.8,1.2,7.3,3.5,10.1c4.6,5.5,12.1,5.5,16.7,0C35.6,43.2,36.8,39.6,36.8,35.8z"
    />
  </SvgIcon>
);

export const PrevIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M5.8,12.72 L16.8,23.72 C17.0536586,23.9736586 17.423374,24.0727235
    17.7698781,23.9798781 C18.1163821,23.8870326 18.3870326,23.6163821
    18.4798781,23.2698781 C18.5727235,22.923374 18.4736586,22.5536586 18.22,22.3
    L7.9,12 L18.2,1.71 C18.4536586,1.45634143 18.5527235,1.08662601 18.4598781,0.74012195
    C18.3670326,0.393617893 18.0963821,0.122967415 17.749878,0.0301219368
    C17.403374,-0.0627235415 17.0336586,0.0363414171 16.78,0.29 L5.78,11.29
    C5.58444813,11.4784832 5.47397406,11.7384002 5.47397406,12.01 C5.47397406,12.2815998
    5.58444813,12.5415168 5.78,12.73 L5.8,12.72 Z"
    />
  </SvgIcon>
);

export const NextIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M20.2,11.28 L9.2,0.28 C8.8084395,-0.0983790773 8.1861154,-0.0939339052
    7.8,0.29 C7.61068735,0.4777666 7.50420168,0.733362464 7.50420168,1 C7.50420168,1.26663754
    7.61068735,1.5222334 7.8,1.71 L18.09,12 L7.8,22.29 C7.61068735,22.4777666
    7.50420168,22.7333625 7.50420168,23 C7.50420168,23.2666375 7.61068735,23.5222334
    7.8,23.71 C8.19003745,24.0977236 8.81996255,24.0977236 9.21,23.71 L20.21,12.71
    C20.4055519,12.5215168 20.5160259,12.2615998 20.5160259,11.99 C20.5160259,11.7184002
    20.4055519,11.4584832 20.21,11.27 L20.2,11.28 Z"
    />
  </SvgIcon>
);

export const CheckedIcon = props => (
  <SvgIcon {...props} viewBox="0 0 25 25">
    <path
      d="M23.72,4.19 C23.3299625,3.80227641 22.7000375,3.80227641
    22.31,4.19 L8.81,17.69 L1.69,10.57 C1.29996255,10.1822764
    0.670037454,10.1822764 0.28,10.57 C0.0875872726,10.7581405
    -0.0208755476,11.0158913 -0.0208755476,11.285 C-0.0208755476,11.5541087
    0.0875872726,11.8118595 0.28,12 L8.1,19.81 C8.28871883,19.9971865
    8.54419702,20.1015368 8.81,20.1 C8.93889225,20.0924312 9.06484332,20.0583904
    9.18,20 C9.3071515,19.9506226 9.42285705,19.8757543 9.52,19.78 L23.72,5.6
    C24.1077236,5.20996255 24.1077236,4.58003745 23.72,4.19 Z"
    />
    ;
  </SvgIcon>
);

export const CloseIcon = props => (
  <SvgIcon {...props} viewBox="0 0 25 24">
    <path d="M10.6013492,12.015 L0.262590181,1.67624099 C-0.127934111,1.2857167 -0.127934111,0.652551724 0.262590181,0.262027432 C0.653114473,-0.128496859 1.28627945,-0.128496859 1.67680374,0.262027432 L12.0155627,10.6007864 L22.355535,0.260814229 C22.7460592,-0.129710063 23.3792242,-0.129710063 23.7697485,0.260814229 C24.1602728,0.651338521 24.1602728,1.2845035 23.7697485,1.67502779 L13.4297763,12.015 L23.7385353,22.323759 C24.1290596,22.7142833 24.1290596,23.3474483 23.7385353,23.7379726 C23.348011,24.1284969 22.714846,24.1284969 22.3243218,23.7379726 L12.0155627,13.4292136 L1.70801695,23.7367594 C1.31749265,24.1272837 0.684327676,24.1272837 0.293803384,23.7367594 C-0.0967209075,23.3462351 -0.0967209075,22.7130701 0.293803384,22.3225458 L10.6013492,12.015 Z" />
    ;
  </SvgIcon>
);

export const SearchIcon = props => (
  <SvgIcon {...props} viewBox="0 0 25 25">
    <path d="M23.729329,22.309329 L19.469329,18.019329 C23.2186586,13.4954894 22.750812,6.82372597 18.4068258,2.86741697 C14.0628397,-1.08889204 7.37651388,-0.932829893 3.22184199,3.22184199 C-0.932829893,7.37651388 -1.08889204,14.0628397 2.86741697,18.4068258 C6.82372597,22.750812 13.4954894,23.2186586 18.019329,19.469329 L22.269329,23.729329 C22.5229876,23.9829876 22.892703,24.0820525 23.2392071,23.9892071 C23.5857111,23.8963616 23.8563616,23.6257111 23.9492071,23.2792071 C24.0420525,22.932703 23.9429876,22.5629876 23.689329,22.309329 L23.729329,22.309329 Z M2.01932901,11.019329 C2.01932901,6.04876627 6.04876627,2.01932901 11.019329,2.01932901 C15.9898918,2.01932901 20.019329,6.04876627 20.019329,11.019329 C20.019329,15.9898918 15.9898918,20.019329 11.019329,20.019329 C6.04876627,20.019329 2.01932901,15.9898918 2.01932901,11.019329 Z" />
  </SvgIcon>
);

export const Ellipsis = props => (
  <SvgIcon {...props} viewBox="0 0 6.3499998 6.3499998">
    <g transform="translate(0,-290.65)">
      <circle r="0.5428912" cx="0.5428912" cy="293.82501" />
      <circle r="0.5428912" cx="3.175" cy="293.82501" />
      <circle r="0.5428912" cx="5.8071084" cy="293.82501" />
    </g>
  </SvgIcon>
);

export const ImageIcon = props => (
  <SvgIcon {...props}>
    <path d="M 47.916667,0 H 2.0833333 A 2.0833333,2.0833333 0 0 0 0,2.0833333 V 47.916667 A 2.0833333,2.0833333 0 0 0 2.0833333,50 H 47.916667 A 2.0833333,2.0833333 0 0 0 50,47.916667 V 2.0833333 A 2.0833333,2.0833333 0 0 0 47.916667,0 Z M 45.833333,4.1666667 V 28.3125 L 40.020833,22.5 a 2.0833333,2.0833333 0 0 0 -2.9375,0 L 25,34.5625 16.0625,25.604167 a 2.0833333,2.0833333 0 0 0 -2.9375,0 L 4.1666667,34.5625 V 4.1666667 Z M 4.1666667,45.833333 V 40.4375 l 10.4166663,-10.416667 8.9375,8.9375 a 2.0833333,2.0833333 0 0 0 2.9375,0 l 12.0625,-12.0625 7,7 v 11.9375 z" />
    <path d="m 14.583333,20.833333 a 6.25,6.25 0 1 0 -6.2499997,-6.25 6.25,6.25 0 0 0 6.2499997,6.25 z m 0,-8.333333 A 2.0833333,2.0833333 0 1 1 12.5,14.583333 2.0833333,2.0833333 0 0 1 14.583333,12.5 Z" />
  </SvgIcon>
);

export const SaveIcon = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M23.6876095,6.62474517 C23.8959063,7.12490252 24,7.58319309 24,8 L24,22.5000205 C24,22.9168822 23.8543126,23.2710805 23.5628831,23.5626702 C23.2712894,23.8540957 22.917141,24 22.5002189,24 L1.49989054,24 C1.08335158,24 0.729093695,23.8540957 0.437390543,23.5626702 C0.145687391,23.2710805 0,22.9168822 0,22.5000205 L0,1.49992475 C0,1.08317257 0.145687391,0.728974264 0.437390543,0.437439286 C0.729093695,0.145740125 1.08335158,0 1.49989054,0 L16.0001095,0 C16.4167032,0 16.8751642,0.104146999 17.3748905,0.312386269 C17.8748905,0.52084445 18.2708516,0.770950485 18.5622811,1.06237601 L22.9373358,5.4374256 C23.2291484,5.72901531 23.4793126,6.12497093 23.6876095,6.62474517 Z M9.96226415,2.76387046 L9.96226415,7.76391151 C9.96226415,7.89952699 10.0117935,8.0164803 10.1107974,8.11564706 C10.2096372,8.21448547 10.3269205,8.26384994 10.4623189,8.26384994 L13.4624831,8.26384994 C13.5975531,8.26384994 13.7147269,8.21432128 13.8136761,8.11564706 C13.9125706,8.01664448 13.9623736,7.89952699 13.9623736,7.76391151 L13.9623736,2.76387046 C13.9623736,2.62847389 13.912899,2.51152059 13.8136761,2.41235382 C13.7147269,2.31351542 13.5975531,2.26415094 13.4624831,2.26415094 L10.4623189,2.26415094 C10.3269205,2.26415094 10.2096919,2.31362487 10.1107974,2.41235382 C10.0117935,2.51152059 9.96226415,2.62847389 9.96226415,2.76387046 Z M17.887285,21.8491934 L17.887285,15.8490566 L5.88679245,15.8490566 L5.88679245,21.8491934 L17.887285,21.8491934 Z M21.8121964,22.2643699 L21.8121417,8.26428776 C21.8121417,8.11849291 21.760259,7.91791553 21.6557822,7.66261036 C21.5516885,7.40752409 21.4474854,7.22763382 21.3433917,7.12348682 L16.9524109,2.73267562 C16.8482625,2.62852862 16.6712704,2.52438162 16.4210515,2.42028935 C16.1707778,2.31614235 15.9677897,2.26415094 15.8115944,2.26415094 L15.8115944,8.76422619 C15.8115944,9.18097837 15.6655239,9.53517668 15.3740944,9.82671166 C15.0828838,10.1182466 14.7282975,10.2641509 14.3118133,10.2641509 L5.31137548,10.2641509 C4.89467233,10.2641509 4.54041445,10.1182466 4.2487113,9.82671166 C3.95700815,9.5350125 3.81132075,9.18097837 3.81132075,8.76422619 L3.81132075,2.26415094 L1.81132075,2.26415094 L1.81132075,22.2643699 L3.81137548,22.2643699 L3.81137548,15.7641851 C3.81137548,15.3473235 3.95722706,14.9931252 4.24876603,14.7015355 C4.54046918,14.4099458 4.89472706,14.2640415 5.31143021,14.2640415 L18.3117586,14.2640415 C18.7282428,14.2640415 19.082446,14.4099458 19.3740397,14.7015355 C19.6656334,14.9933441 19.8113755,15.3473235 19.8113755,15.7641851 L19.8113755,22.2643699 L19.8117586,22.2643699 L21.8121964,22.2643699 Z" />
  </SvgIcon>
);

export const KeyIcon = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M21.8,3.2 C19.4380728,0.814379812 15.777296,0.291723995 12.8421446,1.92107054 C9.90699322,3.55041708 8.41448351,6.93373943 9.19,10.2 L1.19,18.2 C-0.372965842,19.7629658 -0.372965842,22.2970342 1.19,23.86 C2.75296584,25.4229658 5.28703416,25.4229658 6.85,23.86 L14.85,15.86 C15.3951342,15.98023 15.9517651,16.0405875 16.51,16.04 C18.5028021,16.0350433 20.4096122,15.2276228 21.8,13.8 C23.2069553,12.3950471 23.9975431,10.4883198 23.9975431,8.5 C23.9975431,6.51168015 23.2069553,4.60495288 21.8,3.2 Z M20.39,12.39 C19.3625003,13.4216884 17.9660685,14.0011356 16.51,14 C16.0997828,14.0018056 15.6906257,13.9582069 15.29,13.87 L14.21,13.63 L13.43,14.4 L9.37,18.46 L8.85,17.94 C8.45323972,17.6002232 7.86180583,17.6230677 7.49243678,17.9924368 C7.12306773,18.3618058 7.1002232,18.9532397 7.44,19.35 L7.96,19.87 L7.37,20.46 L6.16,19.25 C5.91561012,18.9646238 5.5318816,18.8403181 5.16658103,18.9281899 C4.80128045,19.0160617 4.51606167,19.3012805 4.42818987,19.666581 C4.34031806,20.0318816 4.46462384,20.4156101 4.75,20.66 L6,21.87 L5.45,22.41 C4.66992509,23.1854472 3.41007491,23.1854472 2.63,22.41 C1.85455281,21.6299251 1.85455281,20.3700749 2.63,19.59 L10.63,11.59 L11.4,10.81 L11.16,9.73 C10.5773109,7.15255112 11.9099605,4.52500556 14.3337566,3.47239842 C16.7575527,2.41979128 19.58735,3.2396677 21.0730287,5.42496591 C22.5587073,7.61026411 22.2803038,10.5432561 20.41,12.41 L20.39,12.39 Z M17.5,5 C16.1192881,5 15,6.11928813 15,7.5 C15,8.88071187 16.1192881,10 17.5,10 C18.8807119,10 20,8.88071187 20,7.5 C20,6.11928813 18.8807119,5 17.5,5 Z" />
  </SvgIcon>
);

export const ExitIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M1.99912508,21.9904563 L10.9951843,21.9904563 C11.5472295,21.9904563 11.9947505,22.4379773 11.9947505,22.9900225 C11.9947505,23.5420676 11.5472295,23.9895886 10.9951843,23.9895886 L0.999566194,23.9895886 C0.447522245,23.9895886 1.97324386e-06,23.5420696 6.52542599e-12,22.9900261 L1.11022302e-16,0.999562542 C1.97324386e-06,0.447519055 0.447522245,1.01408828e-16 0.999566194,0 L10.9951843,6.66133815e-16 C11.5472295,5.64724763e-16 11.9947505,0.447521028 11.9947505,0.999566194 C11.9947505,1.55161136 11.5472295,1.99913239 10.9951843,1.99913239 L1.99912508,1.99913239 L1.99912508,21.9904563 Z M20.5704542,12.9943605 L6.99694145,12.9943605 C6.44489628,12.9943605 5.99737525,12.5468395 5.99737525,11.9947943 C5.99737525,11.4427492 6.44489628,10.9952281 6.99694145,10.9952281 L20.5905848,10.9952281 L17.3460462,7.75068953 C16.9556928,7.36033608 16.9556928,6.72744808 17.3460462,6.33709463 C17.7363997,5.94674117 18.3692877,5.94674117 18.7596411,6.33709463 L23.7072465,11.2847 C24.0976,11.6750535 24.0976,12.3079415 23.7072465,12.6982949 C23.6739335,12.731608 23.638854,12.7620781 23.6023096,12.7897053 L18.7527684,17.6392465 C18.3624135,18.0296013 17.7295232,18.0296013 17.3391684,17.6392465 C16.9488135,17.2488916 16.9488135,16.6160013 17.3391684,16.2256464 L20.5704542,12.9943605 Z" />
  </SvgIcon>
);

export const PanIcon = props => (
  <SvgIcon viewBox="0 0 14 24" {...props}>
    <path
      d="M8.5,24 C5.46243388,24 3,21.5375661 3,18.5 L3,10 C3,9.44771525 3.44771525,9 4,9 L13,9 C13.5522847,9 14,9.44771525 14,10 L14,18.5 C14,21.5375661 11.5375661,24 8.5,24 Z M13,17 L13,17.5 C13,19.9852814 10.9852814,22 8.5,22 C8.14621655,22 7.80196856,21.9591739 7.4717103,21.8819759 C7.3311901,21.9572883 7.17058298,22 7,22 C6.53978555,22 6.1521816,21.6891175 6.0357383,21.2659026 C4.8097254,20.4620152 4,19.0755683 4,17.5 L4,11 C3.44771525,11 3,10.5522847 3,10 L3,1 C3,0.44771525 3.44771525,1.01453063e-16 4,0 C4.55228475,-1.01453063e-16 5,0.44771525 5,1 L5,8 L6,8 L6,6 C6,5.44771525 6.44771525,5 7,5 C7.55228475,5 8,5.44771525 8,6 L8,8 L9,8 L9,7 C9,6.44771525 9.44771525,6 10,6 C10.5522847,6 11,6.44771525 11,7 L11,8 L12,8 C12,7.44771525 12.4477153,7 13,7 C13.5522847,7 14,7.44771525 14,8 L14,16 C14,16.5522847 13.5522847,17 13,17 Z M1,18 C0.44771525,18 0,17.5522847 0,17 L0,10 C0,9.44771525 0.44771525,9 1,9 C1.55228475,9 2,9.44771525 2,10 L2,17 C2,17.5522847 1.55228475,18 1,18 Z"
      id="path-1"
    />
  </SvgIcon>
);

export const PointingHandIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M13.5,24A5.5,5.5,0,0,1,8,18.5V10A1,1,0,0,1,9,9h9a1,1,0,0,1,1,1v8.5A5.5,5.5,0,0,1,13.5,24ZM10,11v7.5a3.5,3.5,0,0,0,7,0V11Z" />
    <path d="m 9,8 h 9 v 9.63396 a 4.5,4.5634548 0 0 1 -4.5,4.563455 v 0 A 4.5,4.5634548 0 0 1 9,17.63396 Z" />
    <path d="M12,22a1,1,0,0,1-1-1V6a1,1,0,0,1,2,0V21A1,1,0,0,1,12,22Z" />
    <path d="M15,16a1,1,0,0,1-1-1V7a1,1,0,0,1,2,0v8A1,1,0,0,1,15,16Z" />
    <path d="M9,11a1,1,0,0,1-1-1V1a1,1,0,0,1,2,0v9A1,1,0,0,1,9,11Z" />
    <path d="M18,17a1,1,0,0,1-1-1V8a1,1,0,0,1,2,0v8A1,1,0,0,1,18,17Z" />
    <path d="M6,18a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0v7A1,1,0,0,1,6,18Z" />
  </SvgIcon>
);

export const UpdateIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M23.65,11.93a1,1,0,0,0-1.41.11l-.26.3c0-.11,0-.21,0-.32A11,11,0,1,0,9.89,23,1,1,0,0,0,11,22a1,1,0,0,0-.88-1A9,9,0,1,1,20,12c0,.1,0,.19,0,.28L19.76,12a1,1,0,1,0-1.52,1.3l2,2.34a1,1,0,0,0,1.52,0l2-2.34A1,1,0,0,0,23.65,11.93Z" />
  </SvgIcon>
);

export const ClosedLockIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M23,24H1a1,1,0,0,1-1-.94V8.94A1,1,0,0,1,1,8H23a1,1,0,0,1,1,.94V23.06A1,1,0,0,1,23,24ZM2,22.12H22V9.88H2Z" />
    <path d="M12,2a6,6,0,0,1,6,6h2A8,8,0,0,0,4,8H6A6,6,0,0,1,12,2Z" />
    <path d="M14,20H10a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v6A1,1,0,0,1,14,20Zm-3-2h2V14H11Z" />
  </SvgIcon>
);

export const ClipPathIcon = props => (
  <SvgIcon viewBox="0 0 12 12" {...props}>
    <path
      d="M3.15015 1C3.45015 1 3.65015 1.2 3.65015 1.5V7H7.40015L7.35015 8H3.15015C2.85015 8 2.65015 7.8 2.65015 7.5V1.5C2.65015 1.2 2.90015 1 3.15015 1Z"
      fill="white"
    />
    <path
      d="M8.15 4.15C7.95 4.35 7.95 4.65 8.15 4.85L10.3 7H3.5C3.2 7 3 7.2 3 7.5C3 7.8 3.2 8 3.5 8H10.3L8.15 10.15C7.95 10.35 7.95 10.65 8.15 10.85C8.35 11.05 8.65 11.05 8.85 10.85L11.85 7.85C12.05 7.65 12.05 7.35 11.85 7.15L8.85 4.15C8.65 3.95 8.35 3.95 8.15 4.15Z"
      fill="white"
    />
  </SvgIcon>
);

export const OpenedLockIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M23,24H1a1,1,0,0,1-1-.94V8.94A1,1,0,0,1,1,8H23a1,1,0,0,1,1,.94V23.06A1,1,0,0,1,23,24ZM2,22.12H22V9.88H2Z" />
    <path d="M14,20H10a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v6A1,1,0,0,1,14,20Zm-3-2h2V14H11Z" />
    <path d="M6.1,9a6,6,0,0,1,5.05-7A1,1,0,0,0,12,1a1,1,0,0,0-1.14-1A7.94,7.94,0,0,0,4.08,9Z" />
  </SvgIcon>
);

export const ShareIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M21,18a3,3,0,0,0-2.08.84L6,12.36A3,3,0,0,0,6,12a3,3,0,0,0,0-.36l13-6.48A3,3,0,1,0,18,3a3,3,0,0,0,0,.36l-13,6.48a3,3,0,1,0,0,4.31l13,6.48A3,3,0,0,0,18,21a3,3,0,1,0,3-3Z" />
  </SvgIcon>
);

export const CopyIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M23,0H6A1,1,0,0,0,5,1V5H1A1,1,0,0,0,0,6V23a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V19h4a1,1,0,0,0,1-1V1A1,1,0,0,0,23,0ZM17,22H2V7H17Zm5-5H19V6a1,1,0,0,0-1-1H7V2H22Z" />
  </SvgIcon>
);

export const AnimateIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M12,21.14A9.15,9.15,0,0,1,2.86,12c0-.3,0-.59,0-.88a7.14,7.14,0,1,0,10,10C12.59,21.13,12.3,21.14,12,21.14Z" />
    <circle cx="16.86" cy="7.14" r="7.14" />
    <path d="M16.86,16.28A9.15,9.15,0,0,1,7.72,7.14c0-.3,0-.59,0-.88a7.14,7.14,0,1,0,10,10C17.45,16.27,17.15,16.28,16.86,16.28Z" />
  </SvgIcon>
);

export const EyeIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12,20A13.21,13.21,0,0,1,.07,12.43a1,1,0,0,1,0-.87,13.17,13.17,0,0,1,23.85,0,1,1,0,0,1,0,.87A13.21,13.21,0,0,1,12,20ZM2.14,12a11.12,11.12,0,0,0,19.72,0A11.12,11.12,0,0,0,2.14,12Z" />
  </SvgIcon>
);

export const ListIcon = props => (
  <SvgIcon viewBox="0 0 24 16" {...props}>
    <path
      d="M23,9 L8,9 C7.44771525,9 7,8.55228475 7,8 C7,7.44771525 7.44771525,7 8,7 L23,7 C23.5522847,7 24,7.44771525 24,8 C24,8.55228475 23.5522847,9 23,9 Z M23,16 L8,16 C7.44771525,16 7,15.5522847 7,15
    C7,14.4477153 7.44771525,14 8,14 L23,14 C23.5522847,14 24,14.4477153 24,15 C24,15.5522847 23.5522847,16 23,16 Z M23,2 L8,2 C7.44771525,2 7,1.55228475 7,1 C7,0.44771525 7.44771525,0 8,0 L23,0 C23.5522847,
    0 24,0.44771525 24,1 C24,1.55228475 23.5522847,2 23,2 Z M4,2 L1,2 C0.44771525,2 6.76353751e-17,1.55228475 0,1 C-6.76353751e-17,0.44771525 0.44771525,0 1,0 L4,0 C4.55228475,0 5,0.44771525 5,1 C5,1.55228475
    4.55228475,2 4,2 Z M4,9 L1,9 C0.44771525,9 6.76353751e-17,8.55228475 0,8 C-6.76353751e-17,7.44771525 0.44771525,7 1,7 L4,7 C4.55228475,7 5,7.44771525 5,8 C5,8.55228475 4.55228475,9 4,9 Z M4,16 L1,16 C0.44771525,16
    6.76353751e-17,15.5522847 0,15 C-6.76353751e-17,14.4477153 0.44771525,14 1,14 L4,14 C4.55228475,14 5,14.4477153 5,15 C5,15.5522847 4.55228475,16 4,16 Z"
    />
  </SvgIcon>
);

export const HamburgerIcon = props => (
  <SvgIcon viewBox="0 0 24 16" {...props}>
    <path
      d="M23,2 L1,2 C0.44771525,2 6.76353751e-17,1.55228475 0,1 C-6.76353751e-17,0.44771525 0.44771525,0 1,0
    L23,0 C23.5522847,0 24,0.44771525 24,1 C24,1.55228475 23.5522847,2 23,2 Z M23,9 L1,9 C0.44771525,9 6.76353751e-17,8.55228475
    0,8 C-6.76353751e-17,7.44771525 0.44771525,7 1,7 L23,7 C23.5522847,7 24,7.44771525 24,8 C24,8.55228475 23.5522847,9 23,9 Z M23,16 L1,16
    C0.44771525,16 6.76353751e-17,15.5522847 0,15 C-6.76353751e-17,14.4477153 0.44771525,14 1,14 L23,14 C23.5522847,14 24,14.4477153 24,15 C24,15.5522847
    23.5522847,16 23,16 ZM23,2 L1,2 C0.44771525,2 6.76353751e-17,1.55228475 0,1 C-6.76353751e-17,0.44771525 0.44771525,0 1,0 L23,0 C23.5522847,0 24,0.44771525 24,1
    C24,1.55228475 23.5522847,2 23,2 Z M23,9 L1,9 C0.44771525,9 6.76353751e-17,8.55228475 0,8 C-6.76353751e-17,7.44771525 0.44771525,7 1,7 L23,7 C23.5522847,7 24,7.44771525
    24,8 C24,8.55228475 23.5522847,9 23,9 Z M23,16 L1,16 C0.44771525,16 6.76353751e-17,15.5522847 0,15 C-6.76353751e-17,14.4477153 0.44771525,14 1,14 L23,14 C23.5522847,14 24,14.4477153 24,15
    C24,15.5522847 23.5522847,16 23,16 Z"
    />
  </SvgIcon>
);

export const ExportIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M11,20.6 L11,5 C11,4.44771525 11.4477153,4 12,4 C12.5522847,4 13,4.44771525 13,5 L13,20.6 L17.3,16.3
       C17.6981203,16.0014098 18.2552148,16.0410013 18.6071068,16.3928932 C18.9589987,16.7447852 18.9985902,17.3018797 18.7,17.7 L12.7,23.7
       C12.3111565,24.0811429 11.6888435,24.0811429 11.3,23.7 L5.3,17.7 C5.11158574,17.5153695 5.00375705,17.2637693 5,17 C5.00562006,16.5999248
       5.2491743,16.2417116 5.61915154,16.089368 C5.98912879,15.9370245 6.41429969,16.0198803 6.7,16.3 L11,20.6 Z M0,14 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16
       1,0 L23,0 C23.5522847,3.38176876e-17 24,0.44771525 24,1 L24,14 C24,14.5522847 23.5522847,15 23,15 C22.4477153,15 22,14.5522847 22,14 L22,2 L2,2 L2,14 C2,14.5522847 1.55228475,15 1,15
       C0.44771525,15 6.76353751e-17,14.5522847 0,14 Z"
    />
  </SvgIcon>
);

export const LinkedIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M12.9,15H11a1,1,0,0,1,0-2h1.9a4,4,0,0,0,2.88-1.19l5.51-5.51a2.54,2.54,0,0,0-3.59-3.59l-5,5a1,1,0,0,1-1.41-1.41l5-5a4.54,4.54,0,0,1,6.41,6.41l-5.51,5.51A6,6,0,0,1,12.9,15Z" />
    <path d="M4.54,24a4.53,4.53,0,0,1-3.21-7.74l5.51-5.51A6,6,0,0,1,11.14,9H13a1,1,0,0,1,0,2h-1.9a4,4,0,0,0-2.88,1.19L2.74,17.67a2.54,2.54,0,0,0,3.59,3.59l5-5a1,1,0,0,1,1.41,1.41l-5,5A4.52,4.52,0,0,1,4.54,24Z" />
  </SvgIcon>
);

export const UnlinkedIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M16.08,1.48,10.93,6.63a1,1,0,0,0,0,1.4h0a1,1,0,0,0,1.4,0l5.2-5.2A2.64,2.64,0,0,1,21,2.52a2.52,2.52,0,0,1,.21,3.74l-5.32,5.32a1,1,0,0,0,0,1.4h0a1,1,0,0,0,1.4,0L22.6,7.66A4.49,4.49,0,0,0,22.29,1,4.66,4.66,0,0,0,16.08,1.48Z" />
    <path d="M11.7,15.87,6.45,21.11A2.63,2.63,0,0,1,3,21.39a2.54,2.54,0,0,1-.2-3.76l5.35-5.35a1,1,0,0,0,0-1.41h0a1,1,0,0,0-1.41,0L1.5,16.06a4.71,4.71,0,0,0,0,6.68,4.56,4.56,0,0,0,6.3-.11l5.35-5.35a1,1,0,0,0,0-1.41h0A1,1,0,0,0,11.7,15.87Z" />
    <path d="M16.6,17.52a1,1,0,0,1-.71-.29l-2.12-2.12a1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0l2.12,2.13a1,1,0,0,1,0,1.41A1,1,0,0,1,16.6,17.52Z" />
    <path d="M9.53,10.45a1,1,0,0,1-.71-.29L6.7,8a1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0l2.12,2.12a1,1,0,0,1-.7,1.71Z" />
  </SvgIcon>
);

export const ReplayIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M.35,11.93A1,1,0,0,1,1.76,12l.26.3c0-.1,0-.21,0-.31A11,11,0,1,1,14.11,23,1,1,0,0,1,13,22a1,1,0,0,1,.88-1A9,9,0,1,0,4,12c0,.09,0,.18,0,.28L4.24,12a1,1,0,0,1,1.41-.11,1,1,0,0,1,.11,1.42l-2,2.33a1,1,0,0,1-1.52,0l-2-2.33A1,1,0,0,1,.35,11.93Z" />
  </SvgIcon>
);

export const DivIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M23,14a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V15A1,1,0,0,0,23,14Z" />
    <path d="M23,20a1,1,0,0,0-1,1v1H21a1,1,0,0,0,0,2h2a1,1,0,0,0,.91-.6A.9.9,0,0,0,24,23h0V21A1,1,0,0,0,23,20Z" />
    <path d="M23,8a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V9A1,1,0,0,0,23,8Z" />
    <path d="M11,22H9a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z" />
    <path d="M17,22H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z" />
    <path d="M20,10a1,1,0,0,0,0-2H18V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V16a2,2,0,0,0,2,2H8v2a1,1,0,0,0,2,0V18h6a2,2,0,0,0,2-2V10ZM2,16V2H16V8H9A1,1,0,0,0,8,9v7Zm14,0H10V10h6Z" />
  </SvgIcon>
);

export const TextIcon = props => (
  <SvgIcon
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="1.77783"
      y="1.77777"
      width="28.4448"
      height="28.4444"
      fill="#282828"
    />
    <mask
      id="mask0_43_2292"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="33"
      height="32"
    >
      <path
        d="M22.8871 25.0788L20.8828 20.1909H11.1062L9.08731 25.0788H6.73706L14.9996 5.05263H17.0038L25.3097 25.0788H22.8871ZM11.9569 18.1241H20.0464L16.0088 8.23663L11.9569 18.1241Z"
        fill="white"
      />
      <path d="M11.7897 1.68419H6.73706V3.3684H11.7897V1.68419Z" fill="white" />
      <path d="M18.5263 1.68419H13.4736V3.3684H18.5263V1.68419Z" fill="white" />
      <path d="M25.2634 1.68419H20.2107V3.3684H25.2634V1.68419Z" fill="white" />
      <path
        d="M11.7897 30.3158H6.73706V28.6316H11.7897V30.3158Z"
        fill="white"
      />
      <path
        d="M18.5263 30.3158H13.4736V28.6316H18.5263V30.3158Z"
        fill="white"
      />
      <path
        d="M25.2634 30.3158H20.2107V28.6316H25.2634V30.3158Z"
        fill="white"
      />
      <path
        d="M3.36829 11.7895L3.36829 6.73688H1.68406L1.68406 11.7895H3.36829Z"
        fill="white"
      />
      <path d="M30.316 11.7895V6.73689H28.6318V11.7895H30.316Z" fill="white" />
      <path
        d="M3.36829 18.5262L3.36829 13.4736H1.68406L1.68406 18.5262H3.36829Z"
        fill="white"
      />
      <path d="M30.316 18.5262V13.4736H28.6318V18.5262H30.316Z" fill="white" />
      <path
        d="M3.36829 25.2631L3.36829 20.2105H1.68406L1.68406 25.2631H3.36829Z"
        fill="white"
      />
      <path d="M30.316 25.2631V20.2105H28.6318V25.2631H30.316Z" fill="white" />
      <path d="M5.05268 0H0V5.05262H5.05268V0Z" fill="white" />
      <path d="M32.0001 0H26.9474V5.05262H32.0001V0Z" fill="white" />
      <path d="M32.0001 26.9474H26.9474V32H32.0001V26.9474Z" fill="white" />
      <path d="M5.05268 26.9474H0V32H5.05268V26.9474Z" fill="white" />
    </mask>
    <g mask="url(#mask0_43_2292)">
      <path d="M32.0004 0H0V32H32.0004V0Z" fill="white" />
    </g>
  </SvgIcon>
);

export const SendIcon = props => (
  <SvgIcon viewBox="0 0 512 512" {...props}>
    <path
      d="M472.3,6.8l-256,256c-9.1,9.1-9.1,23.8,0,32.9s23.8,9.1,32.9,0l256-256c9.1-9.1,9.1-23.8,0-32.9
		C496.1-2.3,481.4-2.3,472.3,6.8"
    />
    <path
      d="M488.7,23.3l-22-7.7l-143.5,410L254,269.8c-2.3-5.3-6.5-9.5-11.8-11.8L86.4,188.8l410-143.5L488.7,23.3l-22-7.7L488.7,23.3
		l-7.7-22L15.6,164.2c-9,3.2-15.2,11.5-15.6,21c-0.4,9.5,5.1,18.3,13.8,22.2l201.3,89.5l89.5,201.3c3.9,8.7,12.7,14.2,22.2,13.8
		c9.5-0.4,17.9-6.5,21-15.6L510.7,31c2.9-8.4,0.8-17.8-5.5-24.1c-6.3-6.3-15.7-8.5-24.1-5.5L488.7,23.3z"
    />
  </SvgIcon>
);

export const StopIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <rect width="24" height="24" rx="2" />
  </SvgIcon>
);

export const AlertIcon = props => (
  <SvgIcon viewBox="0 0 17 16" {...props}>
    <path d="M7.40134 0.373338C7.5135 0.14441 7.74641 -0.000505854 8.00134 1.43366e-06C8.25091 -0.000514775 8.47987 0.138405 8.59467 0.360004L15.928 15.0267C16.0352 15.2336 16.0266 15.4814 15.9053 15.6803C15.784 15.8793 15.5677 16.0005 15.3347 16H0.668003C0.437669 16.0005 0.223413 15.882 0.101335 15.6867C-0.0207419 15.4913 -0.0333448 15.2468 0.0680031 15.04L7.40134 0.373338ZM14.148 14.5933L8.00134 2.30667L1.85468 14.5933H14.148ZM8.66667 11.3333C8.66667 11.7015 8.36819 12 8 12C7.63181 12 7.33333 11.7015 7.33333 11.3333V6C7.33333 5.63181 7.63181 5.33333 8 5.33333C8.36819 5.33333 8.66667 5.63181 8.66667 6V11.3333ZM8 14C8.36819 14 8.66667 13.7015 8.66667 13.3333C8.66667 12.9651 8.36819 12.6667 8 12.6667C7.63181 12.6667 7.33333 12.9651 7.33333 13.3333C7.33333 13.7015 7.63181 14 8 14Z" />
  </SvgIcon>
);

export const ExpandIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="m21 2h-7c-0.6 0-1-0.4-1-1 0-0.6 0.4-1 1-1l10 2e-7c0.6-3e-7 1 0.4 1 1v10c0 0.6-0.4 1-1 1-0.3 0-0.5-0.07-0.7-0.3-0.2-0.2-0.3-0.4-0.3-0.7v-7l-5 5c-0.4 0.4-1 0.4-1 0-0.4-0.4-0.4-1 0-1zm-17 20h7c0.6 0 1 0.4 1 1s-0.4 1-1 1h-10c-0.3 0-0.6-0.1-0.7-0.3-0.1-0.1-0.3-0.4-0.3-0.7l1e-6 -10c-3e-7 -0.6 0.4-1 1-1 0.6 0 1 0.4 1 1v7l5-5c0.4-0.4 1-0.4 1 0 0.4 0.4 0.4 1 0 1z" />
  </SvgIcon>
);

export const VideoIcon = props => (
  <SvgIcon viewBox="0 0 80 80" {...props}>
    <path d="m77 0h-73c-1.9 0-3.5 1.6-3.5 3.5v73c0 1.9 1.6 3.5 3.5 3.5h73c1.9 0 3.5-1.6 3.5-3.5v-73c0-1.9-1.6-3.5-3.5-3.5zm-3.2 13h-18v-6.7h18zm-25 53v6.7h-17v-6.7zm-42-6.7v-40h67v40zm25-47v-6.7h17v6.7zm-6.7-6.7v6.7h-18v-6.7zm-18 60h18v6.7h-18zm48 6.7v-6.7h18v6.7z" />
    <path d="m51 39-17-14c-0.9-0.67-2.2-0.033-2.2 1.1v27c0 1.1 1.3 1.7 2.2 1l17-14c0.67-0.53 0.67-1.6 0-2.1z" />
  </SvgIcon>
);
